export default __webpack_public_path__ + "static/media/goose_gray.a77981c8.svg";